<template>
    <table class="table table-widget">
        <thead>
            <tr>
                <th>&nbsp;</th>
                <th v-for="column in columns" class="name">{{column}}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="row in dataRows">
                <td class="name">{{row[categoryProperty]}}</td>
                <td v-for="column in columns" class="data-cell">{{row[column]}}</td>
            </tr>
            <tr v-if="finalRowContainsPercentages">
                <td>&nbsp;</td>
                <td v-for="column in columns" class="percentage-cell" :class="getPercentageClassName(percentageRow[column])">
                    {{percentageRow[column] | percentageDisplay}}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "DetailsTableWidget",
    async created() {
        const {data, metadata} = this.data;
        
        //Copy our data to allow modifying the array without causing weird bugs later on :-)
        const modifyableData = [...data];
        
        this.finalRowContainsPercentages = metadata.finalRowContainsPercentages;
        
        if(this.finalRowContainsPercentages) {
            //Last row is expected to contain percentages of.. something?
            [this.percentageRow] = modifyableData.splice(modifyableData.length - 1);   
        }
        
        this.dataRows = modifyableData;
        this.columns = metadata.orderedColumns;
        this.categoryProperty = metadata.categoryProperty;
    },
    filters: {
        percentageDisplay(pct){
            //Negative values already contain a '-' when stringified
            if(pct <= 0){
                return `${pct}%`;
            }
            
            return `+${pct}%`;
        }
    },
    methods: {
        getPercentageClassName(pct){
            if(pct === 0){
                return 'percentage-zero';
            }
            
            return pct > 0 ? 'percentage-positive' : 'percentage-negative';
        }
    },
    props: {
        /**
         * @type {SankeyTouchpointInfoConfigWidget}
         */
        configuration: {
            type: Object,
            required: true
        },
        data: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        dataRows: [],
        percentageRow: {},
        columns: [],
        categoryProperty: undefined,
        finalRowContainsPercentages: false
    })
}
</script>

<style scoped lang="scss">
    .table-widget {
        td, 
        th {
            border: none;
        }
        
        .name {
            color: #BABABA;
        }
        
        .percentage-cell {
            font-size: 0.9rem;
            
            &.percentage-positive {
                color: #28C43D;
            }

            &.percentage-negative {
                color: #E3141A;
            }
        }
        
        th {
            font-weight: normal;
            font-size: 0.9rem;
        }

        td {
            font-weight: bold;
            font-size: 1.2rem;
            
            &:not(:last-child){
                border-right-style: solid;
                border-right-color: #ECECEC;
                border-right-width: 2px;
                border-radius: 2px;
            }
            
            &.data-cell {
                padding-left: 10px;
            }
        }
    }
</style>
